import React, { Component } from 'react';
import { Row, Col } from 'reactstrap';
import { Link } from 'react-router-dom';
import './casestudy.scss';

// import images
import img1 from '../../assets/images/casestudies/ican.png';
import img2 from '../../assets/images/casestudies/liveli.png';
import img3 from '../../assets/images/casestudies/geria.png';
import img4 from '../../assets/images/casestudies/ilearncloud.png';
import img5 from '../../assets/images/casestudies/inttix.png';
import img6 from '../../assets/images/casestudies/kobo.png';
import img7 from '../../assets/images/casestudies/jaguar.png';
import img8 from '../../assets/images/casestudies/bp.png';
import img9 from '../../assets/images/casestudies/gtco.png';
import img10 from '../../assets/images/casestudies/fastpay.png';
import img11 from '../../assets/images/casestudies/dhl.png';
import img12 from '../../assets/images/casestudies/asml.png';
import img13 from '../../assets/images/casestudies/mkobo.png';
import img14 from '../../assets/images/casestudies/billyronks.png';
import img15 from '../../assets/images/casestudies/alarrt-brand.png';

import { BsArrowUpRight } from 'react-icons/bs';
import VideoReview from '../VideoReview';
import SEO from '../../components/SEO';

class CaseList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            casestudy: [
                {
                    image: img9,
                    title: 'Migration of On-Premise Workload for Financial Institution to AWS Lagos Local Zone for Data Residency Requirements : A Case Study of GT Pensions Managers',
                    desc: `This case study explores the successful migration of GT Pensions Managers' on-premise workload to the Lagos Local Zone, enabling them to adhere to data residency regulations while improving scalability, security, and operational efficiency`,
                    link: '/case-study-of-gt-pensions-managers',
                },
                {
                    image: img14,
                    title: 'BillyRonks selected CloudPlexo as AWS Advanced partner to provide a Well Architected Review & Remediation',
                    desc: `BillyRonks Global Ltd, established in 2018, is a global telecoms firm offering Wholesale Carrier Services, Business and Retail Voice, Value Added Services, and more.`,
                    link: '/billyronks-selected-cloudplexo-as-aws-advanced-partner',
                },
                {
                    image: img13,
                    title: 'Mkobo uses CloudPlexo’s SaaS solution -  to discover cost optimization opportunities and security posture.',
                    desc: `Mkobo Microfinance Bank, based in Nigeria, offers microfinance services to individuals and small businesses, aiming to promote financial inclusion and empower underserved communities.`,
                    link: '/mkobo-uses-cloudplexo-saas-solution',
                },
                {
                    image: img10,
                    title: 'PhastPay collaborated with CloudPlexo experts and leveraging on CloudPlexo SaaS solution',
                    desc: `PhastPay, a Nigerian fintech company, simplifies financial transactions with digital payment solutions for businesses and individuals.`,
                    link: '/phastpay-collaborated-with-cloudplexo-experts-and-leveraging-on-cloudplexo-saas-solution',
                },
                {
                    image: img15,
                    title: 'Alarrt achieves enhanced cost efficiency, elevated security standards, and a highly scalable and efficient infrastructure.',
                    desc: `Alarrt is the essential companion for your journeys. It's a social app designed to keep you updated about road conditions, disturbances, and emergencies along your route in advance.`,
                    link: '/alarrt-achieves-enhanced-cost-efficiency-elevated-security-standards-and-a-highly-scalable-and-efficient-infrastructure',
                },
                {
                    image: img1,
                    title: 'Migrating Web Applications to AWS: A Case Study in the EdTech Sector',
                    desc: `This case study presents the process of migrating a web application for icanonlinetutors.com - an EdTech company to Amazon Web Services (AWS).`,
                    link: '/case-study-in-the-edtech-sector',
                },
                {
                    image: img2,
                    title: 'Liveli Case Study',
                    desc: `Liveli is a company based in Ontario, Canada. Liveli is a Social Networking and Live Entertainment Hub. Users can share their Lifestyle, Earn real money from posts and contents, stream live events, watch live entertainment and stay connected...`,
                    link: '/liveli-case-study',
                },
                {
                    image: img3,
                    title: 'Geria Case Study',
                    desc: `Geria is a company based in the United Kingdom. It connects talented software engineers, developers, designers, and project managers from Africa to UK technology companies...`,
                    link: '/geria-case-study',
                },
                {
                    image: img5,
                    title: 'Inttix Case Study',
                    desc: `Inttix, an artificial intelligence development company. The company is a Data/AI, Analytical cloud first innovative solutions provider offering intelligent data driven business applications to customers.`,
                    link: '/inttix-case-study',
                },
                {
                    image: img6,
                    title: 'Kobo Case Study',
                    desc: `Kobo360 is a company based in Lagos, Nigeria. Kobo360 is Africa’s innovation leader in integrated logistics solutions and truck brokerage services. Kobo360 aggregates end-to-end haulage operations to help cargo owners, truck owners, drivers, ...`,
                    link: '/kobo-case-study',
                },
                {
                    image: img7,
                    title: 'Jaguar & Land Rover Case Study',
                    desc: `JLR, or Jaguar Land Rover, is a British automotive company that specializes in the production of luxury vehicles. JLR is known for its iconic brands, Jaguar and Land Rover, which have a rich heritage and are renowned for their performance, craftsmanship, and...`,
                    link: '/jaguar-and-land-rover-case-study',
                },
                {
                    image: img8,
                    title: 'BP Case Study',
                    desc: `British Petroleum, commonly known as BP, is a multinational oil and gas company headquartered in London, United Kingdom. It is one of the world's largest oil and gas companies and has operations in all areas of the oil and gas industry...`,
                    link: '/bp-case-study',
                },
                {
                    image: img4,
                    title: 'iLearn Cloud Case Study',
                    desc: `Ilearncloud is a company based in the United Kingdom. Ilearncloud (ilearncloud.io)is an online learning management platform for learning cloud computing, ilearncloud offers a wide range of high-quality courses taught by experienced instructors.`,
                    link: '/ilearncloud-case-study',
                },
                {
                    image: img11,
                    title: '',
                    desc: ``,
                    link: '',
                },
                {
                    image: img12,
                    title: '',
                    desc: ``,
                    link: '',
                },
            ],
        };
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    render() {
        return (
            <React.Fragment>
                <SEO
                    title="Cloud Billing Solutions: Case Studies in Cost Optimization and Savings"
                    description="Explore case studies of organizations optimizing cloud costs and maximizing savings through strategies like AWS credits and resource allocation"
                    keywords="Cloud Billing Solutions, Cloud Cost Optimization, AWS Credits, Cost Management, Cloud Spending, Resource Allocation, Billing Challenges"
                />

                <section
                    className="casestudy"
                    style={{ padding: '60px 0 0' }}
                >
                    <div className="casestudy-hero">
                        <div className="casestudy-hero-content">
                            <h2 className="pt-5">Case Studies</h2>
                            <p>
                                Get updated on the most recent developments in
                                the industry, including news, interviews,
                                cutting-edge technologies, and valuable
                                resources.
                            </p>
                        </div>
                    </div>
                    <div className="casestudy-catalog">
                        <VideoReview />

                        <div className="casestudy-list">
                            <Row>
                                {this.state.casestudy.map((cases, key) => (
                                    <Col
                                        lg={3}
                                        md={6}
                                        xs={12}
                                        key={key}
                                        className="mb-5"
                                    >
                                        <div
                                            className={
                                                cases.link === '' &&
                                                cases.desc === '' &&
                                                cases.title === ''
                                                    ? 'casestudy-list-items py-3 px-3'
                                                    : 'casestudy-list-item py-3 px-3'
                                            }
                                        >
                                            <Row className="align-items-center g-3">
                                                <div className="imgcontainer">
                                                    <img
                                                        src={cases.image}
                                                        className="img-fluid"
                                                        alt="Cloud Billing Solutions: Case Studies in Cost Optimization and Savings"
                                                    />
                                                </div>

                                                {cases.link === '' &&
                                                cases.desc === '' &&
                                                cases.title === '' ? null : (
                                                    <>
                                                        <div className="content-title">
                                                            <h5>
                                                                <Link
                                                                    to={
                                                                        cases.link
                                                                    }
                                                                    className="text-dark title"
                                                                >
                                                                    {
                                                                        cases.title
                                                                    }
                                                                </Link>
                                                            </h5>
                                                            <Link
                                                                to={cases.link}
                                                                className="link"
                                                            >
                                                                <BsArrowUpRight />
                                                            </Link>
                                                        </div>

                                                        <p className="text-muted mb-0 desc">
                                                            {cases.desc}
                                                        </p>
                                                    </>
                                                )}
                                            </Row>
                                        </div>
                                    </Col>
                                ))}
                            </Row>
                        </div>
                    </div>
                </section>
            </React.Fragment>
        );
    }
}

export default CaseList;
